import { defineMessages } from "react-intl"

export default defineMessages({
  headerVrTesting: {
    id: "app.components.VrTesting.headerVrTesting",
  },
  vrTesting: {
    id: "app.components.VrTesting.vrTesting",
  },  
})
